__turbopack_context__.v({
  "accordionSlideOverwrite": "resourceHeader-module-scss-module__3zLrMa__accordionSlideOverwrite",
  "fadeIn": "resourceHeader-module-scss-module__3zLrMa__fadeIn",
  "fadeOut": "resourceHeader-module-scss-module__3zLrMa__fadeOut",
  "resourceHeader": "resourceHeader-module-scss-module__3zLrMa__resourceHeader",
  "scaleIn": "resourceHeader-module-scss-module__3zLrMa__scaleIn",
  "scaleOut": "resourceHeader-module-scss-module__3zLrMa__scaleOut",
  "zoomIn": "resourceHeader-module-scss-module__3zLrMa__zoomIn",
  "zoomOut": "resourceHeader-module-scss-module__3zLrMa__zoomOut",
});
